<template>
  <div>
    <component :is="activeThemeComponent" />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { usePreferencesStore } from '@/stores/preferencesStore';
import ProgressGardenView from '@/components/progress/ProgressGardenView.vue';

const preferencesStore = usePreferencesStore();

const themeComponents = {
  garden: ProgressGardenView,
};

const activeThemeComponent = computed(() => {
  return themeComponents[preferencesStore.progressTheme] || ProgressGardenView;
});
</script>
